import type { TDataExportStoreState } from 'App/data-export/store/dataExportStore'
import { translate } from 'i18n/i18n'

export const validateValueTypes = (
  s: TDataExportStoreState,
): {
  valueTypes: TDataExportStoreState['formErrors']['valueTypes']
} => {
  return {
    valueTypes:
      s.formState.valueTypes.length === 0
        ? translate.phrases.banyanApp('Please select at least one value type')
        : null,
  }
}
